export default {"src":"/_next/static/media/earn.a9b41150.svg","height":725,"width":1178,"blurWidth":0,"blurHeight":0};